module.exports = publishpressFutureBulkEditConfig;